
import requireJS from "./require";
import "./repair";
import helper from "./helper";
import url from "./url";
import http from "./http";
import base64 from "./base64";
import md5 from "./md5";
import date from "./date";
import config from "./config";
import flexible from "./flexible";
import component from "./component";
import array from "./array";
import metadata from "./metadata";
import designer from "./designer";
import api from "./api";
import client from "./client";
import layer from "./layer";
import math from "./math";
import express from "./express";
import init from "./init";
import cookies from "./cookies";
import validate from "./validate";
import cachePool from "./cache";
import storage from "./storage";
import idCard from "./idCard";
import transition from "./transition";
import mime from "./filemime";
import buttons from "./buttons";
// import driver from "../driver";
// import unitTest from "./unitTest";
import custom from "./customer";
import enums from "./enums";
import emit from "./emit";
import ws from "./ws";
import ufunc from "./customMathematical";
import * as formula from "./customVerifyFormula";
// import html from './html';
import safe from "./safe";
import file from "./file";
import chart from "./chart";
import screenFull from "./screenFull";
import ui from "./ui";

import wordToHtml from "./wordToHtml";
import event from "./event";
import sandbox from "./sandbox";
import screenZoom from "./screenZoom";
// import aes from './aes';
import sm from "./sm";
import performance from "./performance";
import scrollbar from "./scrollbar";
import stayTimer from "./stayTimer";
import splitUploader from "./splitUploader";
import number from "./number";
import extDefaultCode from "../output/extCode.txt";
import flow from "./flow";
import format from "./format";

let global = window || global;

let dsf = {};
let curUrl = url.parse(window.location.href);
if (curUrl.searchQuery._debug == "1") {
  window.dsfDebug = true;
  helper.warn("开启debug");
  performance.open();
}
performance.start("创建core");
let _dsf = {
  cacheTime: new Date().getTime(),
  screenZoom,
  performance,
  number,
  ...sm, //国密
  event,
  emit,
  ui,
  sandbox,
  //decimal: Decimal,
  chart,
  version: "5.0",
  init,
  api,
  ...helper,
  url,
  http,
  base64,
  // aes,
  md5,
  flexible,
  date,
  config,
  ...component,
  array,
  global,
  metadata,
  ...requireJS,
  designer,
  client,
  layer,
  math,
  formula: { ...formula },
  express,
  enums,
  validate,
  cachePool,
  storage,
  idCard,
  idCode: idCard,
  mime,
  buttons,
  // driver,
  // unitTest,
  custom,
  ws,
  ufunc,
  safe,
  file,
  screenFull,
  stayTimer,
  ...splitUploader,
  // htmlParse: function (str) {
  //   return html.parse(str)
  // },
  transition: {
    ...transition
  },
  wordToHtml,
  htmlToText: function (node) {
    let str = [];
    for (let i = 0; i < node.childNodes.length; i++) {
      let c = node.childNodes[i];
      if (c.nodeType == 3) {
        let s = c.nodeValue.replace(/\n|\r|\r\n/g, "");
        str.push(s);
      } else if (c.nodeType == 1) {
        // if(c.innerText.indexOf("2")>=0){
        // }
        let isBlock = $(c).css("display") == "block";
        let tagName = c.tagName.toLowerCase();
        let indent = 0;
        let indentValue = c.style.textIndent || "0px";
        let marginLeftValue = c.style.marginLeft || "0px";
        if (marginLeftValue) {
          marginLeftValue = parseFloat(marginLeftValue);
        }
        if (indentValue) {
          indentValue = parseFloat(indentValue);
        }
        let fontsize = $(c).css("font-size");
        if (fontsize) {
          fontsize = parseFloat(fontsize);
        }
        if (isBlock) {
          indent = indentValue || 0;
          indent = marginLeftValue + indentValue || 0;
        } else {
          indent = marginLeftValue || 0;
        }

        let indentArr = [];
        if (indent && fontsize) {
          let x = Math.ceil(indent / fontsize);
          for (let i = 0; i < x; i++) {
            indentArr.push("　");
          }
        }
        if ($(c).text()) {
          if (isBlock) {
            str.push("\n");
            str.push(...indentArr);
            str.push(dsf.htmlToText(c));
          } else if (tagName == "br") {
            str.push("\n");
          } else {
            str.push(...indentArr);
            str.push(dsf.htmlToText(c));
          }
        }
      }
    }
    return str.join("");
  },
  scrollbar,
  momoryRelease() {
    //chrome的bug，当一个被聚焦过的文本框被移除，会导致该文本框相关内存无法销毁，
    let input_focus_memory = $("#chrome_input_focus_memory");
    if (input_focus_memory.length <= 0) {
      input_focus_memory = $("<input id='chrome_input_focus_memory' style='position:fixed;opacity:0;top:-9999px;left:-9999px;z-index:-1;transform: scale(0);'>").appendTo(document.body);
    }
    input_focus_memory.focus().blur();

    //当内页任意元素点击后element-ui会记录触发的事件实例到静态变量中，导致内页组件无法销毁
    var e = document.createEvent("MouseEvent");
    e.initEvent("mousedown", true, true);
    document.body.dispatchEvent(e);
  },
  flow,
  format,
  extDefaultCode
};
dsf = {
  ...dsf,
  ..._dsf
};
if (cookies) {
  dsf.mix(dsf, { cookies: cookies });
}
if (window.$$func) {
  dsf.mix(dsf, { $$func: window.$$func });
  delete window.$$func;
}
performance.end("创建core");

var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
function validateComponentName(name) {
  if (!new RegExp("^[a-zA-Z][\\-\\.0-9_".concat(unicodeRegExp.source, "]*$")).test(name)) {
    dsf.warn('Invalid component name: "' + name + '". Component names ' + "should conform to valid custom element name in html5 specification.");
  }
}

//如果window对象存在则表示在客户端运行，否则使用node的global对象作为全局对象
if (global) {
  performance.start("注入全局对象");

  if (helper.isUnDef(global.$mixins)) {
    global.$mixins = {};
  }
  if (helper.isUnDef(global.$platformRouter)) {
    global.$platformRouter = {
      pc: [],
      mobile: [],
      designer: []
    };
  }
  if (helper.isUnDef(global.$i18n)) {
    global.$i18n = {};
  }
  if (helper.isUnDef(global.$components)) {
    global.$components = {};
  }
  if (helper.isUnDef(global.$platformStore)) {
    global.$platformStore = {};
  }
  if (helper.isUnDef(global.$buttons)) {
    global.$buttons = {
      pc: null,
      mobile: null
    };
  }
  if (helper.isUnDef(global.dsf)) {
    global.dsf = dsf;
  }
  if (dsf.isUnDef(global.$isMobile)) {
    Object.defineProperty(
      global,
      "$isMobile",
      (function () {
        let isMobile = false;
        return {
          get() {
            return isMobile;
          },
          set(v) {
            isMobile = v;
          }
        };
      })()
    );
  }
  global.$const = Object.freeze({
    subTableEmptyRowHash: "__virtual_row_hash__"
  });

  if (window.Vue) {
    let __cache__ = new Map();
    Vue.defineLazyComponent = function (lazyFactory) {
      let factory = function (resolve, reject) {
        //写这个函数的目的是当该组件被路由使用的时候可以正常加载
        try {
          resolve(factory.resolved);
        } catch (ex) {
          reject(ex);
        }
      };
      factory.$lazy = true;
      Object.defineProperty(factory, "resolved", {
        get() {
          if (!__cache__.has(lazyFactory)) {
            let options = lazyFactory();
            options = dsf.getEsModule(options);
            let Ctor = dsf.ensureVueCtor(options, Vue);
            Ctor.realOptions = options;
            __cache__.set(lazyFactory, Ctor);
          }
          return __cache__.get(lazyFactory);
        },
        set(v) {},
        enumerable: true,
        configurable: true
      });
      return factory;
    };
  }
  performance.end("注入全局对象");
}

export default dsf;
